<template>
  <div class="container content-body flex-grow mx-auto max-w-7xl px-4 py-4 sm:px-8">
    <slot name="header"></slot>
    <slot></slot>
  </div>
</template>
